import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import Index from '@/views/Index.vue'
import Feed from '@/views/Feed.vue'
import Explore from '@/views/Explore.vue'
import pPostId from '@/views/p/_postId.vue';
import Message from '@/views/message/Index.vue';

import { routerCustom } from "./router-custom";
Vue.use(VueRouter);

// 解决重复点击路由报错的BUG
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
      return savedPosition;
  } else {
      const position = {};
      // scroll to anchor by returning the selector
      if (to.hash) {
          position.selector = to.hash;
      }
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some(m => m.meta.scrollToTop)) {
          // cords will be used if no selector is provided,
          // or if the selector didn't match any element.
          position.x = 0
          position.y = 0
      }
      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return position;
  }
};

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/feed',
    name: 'feed',
    component: Feed
  },
  {
    path: '/explore',
    name: 'explore',
    component: Explore
  },
  {
    "path": "/p/:postId",
    "meta": {},
    "name": "pPostId",
    "component": pPostId,
  },
  {
    "path": "/edit/article",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "editArticle",
    component: () => import(/* webpackChunkName: "editArticle" */ '@/views/edit/Article.vue')
  },
  {
    "path": "/edit/album",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "editAlbum",
    component: () => import(/* webpackChunkName: "editAlbum" */ '@/views/edit/Album.vue')
  },
  {
    "path": "/edit/shop",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "editShop",
    component: () => import(/* webpackChunkName: "editShop" */ '@/views/edit/Shop.vue')
  },
  {
    "path": "/search",
    "meta": {},
    "name": "search",
    component: () => import(/* webpackChunkName: "search" */ '@/views/Search.vue')
  },
  {
    "path": "/message/:userId",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "messageUserId",
    component: () => import(/* webpackChunkName: "messageUserId" */ '@/views/message/_userId/Index.vue')
  },
  {
    "path": "/message",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "message",
    component: Message
  },
  {
    "path": "/notice/comment",
    "meta": {},
    "name": "noticeComment",
    component: () => import(/* webpackChunkName: "noticeComment" */ '@/views/notice/comment.vue')
  },
  {
    "path": "/notice/like",
    "meta": {},
    "name": "noticeLike",
    component: () => import(/* webpackChunkName: "noticeLike" */ '@/views/notice/like.vue')
  },
  {
    "path": "/bind",
    "meta": {},
    "name": "bind",
    "component": () => import(/* webpackChunkName: "bind" */ '@/views/Bind.vue')
  },
  {
    "path": "/dashboard/dev",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "dashboardDev",
    "component": () => import(/* webpackChunkName: "dashboardDev" */ '@/views/dashboard/Dev.vue')
  },
  {
    "path": "/dashboard/income",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "dashboardIncome",
    "component": () => import(/* webpackChunkName: "dashboardIncome" */ '@/views/dashboard/Income.vue')
  },
  {
    "path": "/dashboard/mark-post",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "dashboardMark-post",
    "component": () => import(/* webpackChunkName: "dashboardMark-post" */ '@/views/dashboard/Mark-post.vue')
  },
  {
    "path": "/dashboard/mark",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "dashboardMark",
    "component": () => import(/* webpackChunkName: "dashboardMark" */ '@/views/dashboard/Mark.vue')
  },
  {
    "path": "/dashboard/order",
    "meta": {
        "scrollToTop": true,
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "dashboardOrder",
    "component": () => import(/* webpackChunkName: "dashboardOrder" */ '@/views/dashboard/Order.vue')
  },
  {
    "path": "/dashboard/purchased",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "dashboardPurchased",
    "component": () => import(/* webpackChunkName: "dashboardPurchased" */ '@/views/dashboard/Purchased.vue')
  },
  {
    "path": "/dashboard/sponsored-bill",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "dashboardSponsored-bill",
    "component": () => import(/* webpackChunkName: "dashboardSponsored-bill" */ '@/views/dashboard/Sponsored-bill.vue')
  },
  {
    "path": "/dashboard/sponsoring",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "dashboardSponsoring",
    "component": () => import(/* webpackChunkName: "dashboardSponsoring" */ '@/views/dashboard/Sponsoring.vue')
  },
  {
    "path": "/dashboard/sponsors",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "dashboardSponsors",
    "component": () => import(/* webpackChunkName: "dashboardSponsors" */ '@/views/dashboard/Sponsors.vue')
  },
  {
    "path": "/dashboard/stats",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "dashboardStats",
    "component": () => import(/* webpackChunkName: "dashboardStats" */ '@/views/dashboard/Stats.vue')
  },
  {
    "path": "/a/:slug/album",
    "meta": {
        "requiresRedirect": true,
        "scrollToTop": true
    },
    "name": "aSlugAlbum",
    "component": () => import(/* webpackChunkName: "aSlugAlbum" */ '@/views/slug/album/Index.vue')
  },
  {
    "path": "/@:slug/album",
    "meta": {
        "requiresRedirect": true,
        "scrollToTop": true
    },
    "name": "slugAlbum",
    "redirect": { name: 'aSlugAlbum' },
    // "component": () => import(/* webpackChunkName: "slugAlbum" */ '@/views/slug/album/Index.vue')
  },
  {
    "path": "/a/:slug",
    "meta": {
        "requiresRedirect": true,
        "scrollToTop": true
    },
    "name": "aSlug",
    "component": () => import(/* webpackChunkName: "aSlug" */ '@/views/slug/Index.vue')
  },
  {
      "path": "/@:slug",
      "meta": {
          "requiresRedirect": true,
          "scrollToTop": true
      },
      "name": "slug",
      "redirect": { name: 'aSlug' },
      // "component": () => import(/* webpackChunkName: "slug" */ '@/views/slug/Index.vue')
  },
  {
    "path": "/a/:slug/plan",
    "meta": {
        "requiresRedirect": true,
        "scrollToTop": true
    },
    "name": "aSlugPlan",
    "component": () => import(/* webpackChunkName: "aSlugPlan" */ '@/views/slug/plan/Index.vue')
  },
  {
      "path": "/@:slug/plan",
      "meta": {
          "requiresRedirect": true,
          "scrollToTop": true
      },
      "name": "slugPlan",
      "redirect": { name: 'aSlugPlan' },
      // "component": () => import(/* webpackChunkName: "slugPlan" */ '@/views/slug/plan/Index.vue')
  },
  {
    "path": "/a/:slug/thank",
    "meta": {
        "requiresRedirect": true,
        "scrollToTop": true
    },
    "name": "aSlugThank",
    "component": () => import(/* webpackChunkName: "aSlugThank" */ '@/views/slug/thank/Index.vue')
}, 
  {
      "path": "/@:slug/thank",
      "meta": {
          "requiresRedirect": true,
          "scrollToTop": true
      },
      "name": "slugThank",
      "redirect": { name: 'aSlugThank' },
      // "component": () => import(/* webpackChunkName: "slugThank" */ '@/views/slug/thank/Index.vue')
  },  
  {
    "path": "/u/:userId",
    "meta": {
        "requiresRedirect": true,
        "scrollToTop": true
    },
    "name": "uUserId",
    "component": () => import(/* webpackChunkName: "uUserId" */ '@/views/u/_userId/Index.vue')
  },
  {
    "path": "/album/:albumId/:postId",
    "meta": {},
    "name": "albumAlbumIdPostId",
    "component": () => import(/* webpackChunkName: "albumAlbumIdPostId" */ '@/views/album/_albumId/_postId.vue')
  },
  {
    "path": "/album/:albumId",
    "meta": {},
    "name": "albumAlbumId",
    "component": () => import(/* webpackChunkName: "albumAlbumId" */ '@/views/album/_albumId/Index.vue')
  },
  {
    "path": "/apply/certify",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "applyCertify",
    "component": () => import(/* webpackChunkName: "applyCertify" */ '@/views/apply/Certify.vue')
  },
  {
    "path": "/apply",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "apply",
    "component": () => import(/* webpackChunkName: "apply" */ '@/views/apply/Index.vue')
  },
  {
    "path": "/group/:groupId",
    "meta": {},
    "name": "groupGroupId",
    "component": () => import(/* webpackChunkName: "groupGroupId" */ '@/views/group/_groupId.vue')
  },
  {
    "path": "/bundle/:planId",
    "meta": {},
    "name": "bundlePlanId",
    "component": () => import(/* webpackChunkName: "item" */ '@/views/item/index.vue')
  },
  {
    "path": "/item/:planId",
    "meta": {},
    "name": "itemPlanId",
    "component": () => import(/* webpackChunkName: "item" */ '@/views/item/index.vue')
  },
  {
    "path": "/item",
    "meta": {},
    "name": "item",
    "component": () => import(/* webpackChunkName: "item" */ '@/views/item/index.vue')
  },
  {
    "path": "/purchase/sku/:skuId",
    "meta": {
      "requiresAuth": true,
      "requiresRedirect": true
    },
    "name": "purchaseSkuSkuId",
    "component": () => import(/* webpackChunkName: "purchaseSkuSkuId" */ '@/views/purchase/sku/skuId.vue')
  },
  {
    "path": "/leaflet",
    "meta": {},
    "name": "leaflet",
    "component": () => import(/* webpackChunkName: "leaflet" */ '@/views/leaflet/Index.vue')
  },
  {
    "path": "/my/bill",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "myBill",
    "component": () => import(/* webpackChunkName: "myBill" */ '@/views/my/Bill.vue')
  },
  {
    "path": "/my/dashboard",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "myDashboard",
    "component": () => import(/* webpackChunkName: "myDashboard" */ '@/views/my/Dashboard.vue')
  },
  {
    "path": "/oauth/wechat",
    "meta": {},
    "name": "oauthWechat",
    "component": () => import(/* webpackChunkName: "oauthWechat" */ '@/views/oauth/Wechat.vue')
  },
  {
    "path": "/oauth2/authorize",
    "meta": {
      "requiresAuth": true,
      "requiresRedirect": true
    },
    "name": "oauth2Authorize",
    component: () => import(/* webpackChunkName: "oauth2Authorize" */ '@/views/oauth2/authorize.vue')
  },
  {
    "path": "/order/check",
    "meta": {
        "scrollToTop": true
    },
    "name": "orderCheck",
    "component": () => import(/* webpackChunkName: "orderCheck" */ '@/views/order/Check.vue')
  },
  {
    "path": "/order/create",
    "meta": {
        "scrollToTop": true
    },
    "name": "orderCreate",
    "component": () => import(/* webpackChunkName: "orderCreate" */ '@/views/order/Create.vue')
  },
  {
    "path": "/order/delivery",
    "meta": {
        "scrollToTop": true
    },
    "name": "orderDelivery",
    "component": () => import(/* webpackChunkName: "orderDelivery" */ '@/views/order/Delivery.vue')
  },
  {
    "path": "/order/inspect",
    "meta": {
      "requiresAuth": true,
      "requiresRedirect": true
    },
    "name": "orderInspect",
    "component": () => import(/* webpackChunkName: "orderInspect" */ '@/views/order/Inspect.vue')
  },
  {
    "path": "/redeem/:redeemId",
    "meta": {},
    "name": "redeemRedeemId",
    "component": () => import(/* webpackChunkName: "redeemRedeemId" */ '@/views/redeem/_redeemId/Index.vue')
  },
  {
    "path": "/setting/account",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingAccount",
    "component": () => import(/* webpackChunkName: "settingAccount" */ '@/views/setting/Account.vue')
  },
  {
    "path": "/setting/badge",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true,
        "scrollToTop": true
    },
    "name": "settingBadge",
    "component": () => import(/* webpackChunkName: "settingBadge" */ '@/views/setting/Badge.vue')
  },
  {
    "path": "/setting/blocklist",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingBlocklist",
    "component": () => import(/* webpackChunkName: "settingBlocklist" */ '@/views/setting/Blocklist.vue')
  },
  {
    "path": "/setting/creator",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingCreator",
    "component": () => import(/* webpackChunkName: "settingCreator" */ '@/views/setting/Creator.vue')
  },
  {
    "path": "/setting/goal",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingGoal",
    "component": () => import(/* webpackChunkName: "settingGoal" */ '@/views/setting/Goal.vue')
  },
  {
    "path": "/setting/group",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingGroup",
    "component": () => import(/* webpackChunkName: "settingGroup" */ '@/views/setting/Group.vue')
  },
  {
    "path": "/setting/notification",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingNotification",
    "component": () => import(/* webpackChunkName: "settingNotification" */ '@/views/setting/Notification.vue')
  },
  {
    "path": "/setting/payment",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingPayment",
    "component": () => import(/* webpackChunkName: "settingPayment" */ '@/views/setting/Payment.vue')
  },
  {
    "path": "/setting/plan",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingPlan",
    "component": () => import(/* webpackChunkName: "settingPlan" */ '@/views/setting/Plan.vue')
  },
  {
    "path": "/setting/privacy",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingPrivacy",
    "component": () => import(/* webpackChunkName: "settingPrivacy" */ '@/views/setting/Privacy.vue')
  },
  {
    "path": "/setting/redeem",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingRedeem",
    "component": () => import(/* webpackChunkName: "settingRedeem" */ '@/views/setting/Redeem.vue')
  },
  {
    "path": "/setting/rejectlist",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingRejectlist",
    "component": () => import(/* webpackChunkName: "settingRejectlist" */ '@/views/setting/Rejectlist.vue')
  },
  {
    "path": "/setting/shop",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingShop",
    "component": () => import(/* webpackChunkName: "settingShop" */ '@/views/setting/Shop.vue')
  },
  {
    "path": "/setting/withdraw",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingWithdraw",
    "component": () => import(/* webpackChunkName: "settingWithdraw" */ '@/views/setting/Withdraw.vue')
  },
  {
    "path": "/setting/identity",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingIdentity",
    "component": () => import(/* webpackChunkName: "settingIdentity" */ '@/views/setting/Identity.vue')
  },
  {
    "path": "/setting/contacts",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingContacts",
    "component": () => import(/* webpackChunkName: "settingContacts" */ '@/views/setting/Contacts.vue')
  },
  {
    "path": "/setting/close-account",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "settingClose-account",
    "component": () => import(/* webpackChunkName: "settingClose-account" */ '@/views/setting/Close-account.vue')
  },
  {
    "path": "/login",
    "meta": {
        "scrollToTop": true
    },
    "name": "login",
    "component": () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
  },
  {
    "path": "/reg",
    "meta": {
        "scrollToTop": true
    },
    "name": "reg",
    "component": () => import(/* webpackChunkName: "reg" */ '@/views/Reg.vue')
  },
  {
    "path": "/cashier",
    "meta": {
        "scrollToTop": true
    },
    "name": "cashier",
    "component": () => import(/* webpackChunkName: "cashier" */ '@/views/Cashier.vue')
  },
  {
    "path": "/about",
    "meta": {
        "scrollToTop": true
    },
    "name": "about",
    "component": () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
  },
  {
    "path": "/app",
    "meta": {},
    "name": "app",
    "component": () => import(/* webpackChunkName: "app-download" */ '@/views/app/Index.vue')
  },
  {
    "path": "/app/openapp",
    "meta": {},
    "name": "appOpenapp",
    "component": () => import(/* webpackChunkName: "app-openapp" */ '@/views/app/Openapp.vue')
  },
  {
    "path": "/check",
    "meta": {},
    "name": "check",
    "component": () => import(/* webpackChunkName: "check" */ '@/views/Check.vue')
  },
  {
    "path": "/compose",
    "meta": {},
    "name": "compose",
    "component": () => import(/* webpackChunkName: "check" */ '@/views/Compose.vue')
  },
  {
    "path": "/forgot",
    "meta": {},
    "name": "forgot",
    "component": () => import(/* webpackChunkName: "forgot" */ '@/views/Forgot.vue')
  },
  {
    "path": "/link",
    "meta": {},
    "name": "link",
    "component": () => import(/* webpackChunkName: "link" */ '@/views/Link.vue')
  },
  {
    "path": "/privacy",
    "meta": {},
    "name": "privacy",
    "component": () => import(/* webpackChunkName: "privacy" */ '@/views/Privacy.vue')
  },
  {
    "path": "/reset",
    "meta": {},
    "name": "reset",
    "component": () => import(/* webpackChunkName: "reset" */ '@/views/Reset.vue')
  },
  {
    "path": "/term",
    "meta": {
        "scrollToTop": true
    },
    "name": "term",
    "component": () => import(/* webpackChunkName: "term" */ '@/views/Term.vue')
  },
  {
    "path": "/testxxx",
    "meta": {},
    "name": "testxxx",
    "component": () => import(/* webpackChunkName: "testxxx" */ '@/views/Testxxx.vue')
  },
  {
    "path": "/withdraw",
    "meta": {
        "requiresAuth": true,
        "requiresRedirect": true
    },
    "name": "withdraw",
    "component": () => import(/* webpackChunkName: "withdraw" */ '@/views/Withdraw.vue')
  },
  {
    "path": "/error",
    "meta": {},
    "name": "error",
    "alias": "*",
    "component": () => import(/* webpackChunkName: "error" */ '@/views/Error.vue')
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  scrollBehavior,
  routes
})


export default routerCustom(router)
